import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** Scopes SDK theme tokens; required on portaled overlay surfaces. */
export const SPECTRE_SNAP_CLASS = "spectre-snap"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
